<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12pojiG/tc-custom/9780718011307.jpg?1725149283334" alt="This image is the cover for the book Kidnapped by the Taliban"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kidnapped by the Taliban
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Being abducted and held captive by the Taliban isn't a tale many survive to tell. An American doctor shares the harrowing story about the four days he spent with his captors after being abducted on a humanitarian mission and his incredible rescue by SEAL Team Six.</b></p><p>On December 5, 2012, American medical doctor Dilip Joseph and two colleagues are driving back to Kabul, Afghanistan, after serving villagers that morning at a rural clinic. Suddenly a man waving an AK-47 blocks their path. More armed men jump out of hiding. For Dilip, it is the beginning of a nightmare—he’s being kidnapped by the Taliban.</p><p>Dilip recounts his story with chilling detail, transporting the reader to rural Afghanistan. “As we walk, I fear the worst—that when we reach the top, they will shoot us. God, however this is going to end, please don’t let them torture me to death. Let it be one shot and done.”</p><p>Dilip and his friends endure a nine-hour march into the mountains, gruesome images of torture and death, and repeated threats of execution. After four days of uncertainty, gunfire announces the arrival of Navy SEAL Team Six, the elite group of soldiers that took down al-Qaeda founder Osama bin Laden. SEAL team member Nicolas D. Checque loses his life in the rescue, as do the Taliban kidnappers.</p><p>Yet this is more than a story of desperation, survival, and loss. It is also a tale of surprising connection, compassion, and inspiration. As Dilip begins to view the Taliban not as monsters but as men, both he and his captors are challenged to re-examine everything that matters: courage, sacrifice, hope, and faith. The book includes:</p>First-hand account of a Taliban kidnapping survivorInsights into the Taliban's daily existenceInsights into the sacrifices made by the American armed forcesIncludes a glossary and map of Afghanistan<p><i>Kidnapped by the Taliban</i> is a story of both terror and triumph. After reading this dramatic and inspiring account, you will never view Afghanistan or the Taliban in the same way again.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dilip Joseph, James Lund
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d3812ec